import { defineComponent as _defineComponent } from 'vue'

enum ColorScheme {
  Base = 'Base',
}

const __default__ = {}
export { ColorScheme as OzTooltipColorScheme }

import OzBasePopover, { OzBasePopoverColors, type Anchor } from '@@/library/v4/components/OzBasePopover.vue'
import type { ComputePositionConfig } from '@floating-ui/vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzTooltip',
  props: {
    anchor: null,
    config: null,
    darkMode: { type: [Boolean, String], default: 'auto' },
    colorScheme: { default: ColorScheme.Base }
  },
  setup(__props: any) {



return { __sfc: true,ColorScheme, OzBasePopover, OzBasePopoverColors }
}

})